export default async ({ redirect, store }) => {
  const user = store.getters['user/get'];
  if (user === null || !user.admin) {
    redirect('/users/login/');
  }
};
